/* eslint-disable @reatom/unit-naming-rule */
import { action } from '@reatom/framework'
import i18next from 'i18next'

import { Result } from '@blade/std-lib'
import { TradeSettings } from '@root/entities/trade-settings'
import { reatomRequest } from '@root/shared/lib'
import { showSnackbarAction } from '@root/shared/ui-kit'

import { tradeSettingsModel } from './reatom-trade-settings'
import { updateTradeSettingsPresetRequestAction } from './trade-settings-requests'

import type { Network } from '@root/entities/network'

export const reatomUpdateTradeSettings = ({
  network,
  presetIndex,
}: {
  network: Network.Network
  presetIndex: number
}) => {
  const executeAction = action((ctx, settings: TradeSettings.TradeSettings) => {
    const settingsDto = TradeSettings.toDto(settings)

    return updateTradeSettingsPresetRequestAction(ctx, {
      network: network,
      settings: settingsDto,
      preset: presetIndex,
    })
  })

  const updateStateAtom = reatomRequest({
    execAction: executeAction,
    name: `${network}.updateTradeSettings`,
    onResult: (ctx, result) => {
      if (Result.isSuccess(result)) {
        tradeSettingsModel.setTradeSettingsPresets(ctx, {
          network,
          presets: result.success,
        })
        showSnackbarAction(ctx, {
          text: i18next.t('trade_settings.saved'),
          intent: 'success',
        })
      } else {
        showSnackbarAction(ctx, {
          text: i18next.t('common.something-went-wrong'),
          intent: 'error',
        })
      }
    },
  })

  return updateStateAtom
}
